export default __webpack_public_path__ + "static/media/dark-universes-banner-portrait.0f501969.jpg";